import { useEffect } from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";

import { registerWorkspaceHeader } from "../../../lib/nav";
import { useMe } from "../../../lib/session";
import { RouteFallback } from "../../../shell/RouteFallback";
import { useProjectAddress } from "../../../shell/project";
import { simulateNav } from "../../../workspaces/worlds/nav";

export const Route = createFileRoute("/_console/p/$org/$project/simulate")({
  component: WorldsLayout,
});

function WorldsLayout() {
  const session = useMe();
  const address = useProjectAddress();
  useEffect(
    () =>
      registerWorkspaceHeader({
        workspace: "worlds",
        items: simulateNav(address),
        presentation: "tabs",
      }),
    [address],
  );
  if (session.isLoading) return <RouteFallback />;
  return <Outlet />;
}
